﻿import { ApiResourceFactory } from '../api.resource.factory'
import { SimpleValueModel, DictionaryModel, ColumnModel, ResponseListModel } from '../api.models'
import { CommonHelper } from '../../../helpers/common-helper'

export interface IDictionariesService {
    getVersion(): ng.IPromise<SimpleValueModel<number>>
    getDictionaries(withActiveViews: boolean): ng.IPromise<string>
    getAlarmTypes(): ng.IPromise<ResponseListModel<ColumnModel>>
    getDictionaryReferenceTables(referenceTypeIds: number[]): ng.IPromise<string>
}

export class DictionariesService implements IDictionariesService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    public getVersion(): ng.IPromise<SimpleValueModel<number>> {
        var getVersion: ng.resource.IResourceMethod<ng.resource.IResource<SimpleValueModel<number>>> = this.apiResource.dictionaries['getVersion']
        return getVersion().$promise.catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    public getDictionaries(withActiveViews: boolean): ng.IPromise<string> {
        return this.apiResource.dictionaries.get({ views: withActiveViews }).$promise.then((result: SimpleValueModel<string>) => {
            return result.value
        }).catch<any>(rej => {
            return CommonHelper.handleRejection(this.apiResource, rej.status)
        })
    }

    public getAlarmTypes(): ng.IPromise<ResponseListModel<ColumnModel>> {
        /*
        var getAlarmTypes: ng.resource.IResourceMethod<ng.resource.IResource<ColumnModel[]>> = this.apiResource.dictionaries['getAlarmTypes']
        return getAlarmTypes().$promise.then((res) => { return (<any>res).toJSON() }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
        */
        var getAlarmTypes: ng.resource.IResourceMethod<ng.resource.IResource<ResponseListModel<ColumnModel>>> = this.apiResource.dictionaries['getAlarmTypes']
        return getAlarmTypes()
            .$promise.then(result => {
                CommonHelper.checkResultError(result)
                return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    public getDictionaryReferenceTables(referenceTypeIds: number[]): ng.IPromise<string> {
        return this.apiResource.dictionaries['getDictionaryReferenceTables'](referenceTypeIds).$promise.then((result: SimpleValueModel<string>) => {
            return result.value
        }).catch(rej => {
            return CommonHelper.handleRejection(this.apiResource, rej.status)
        })
    }
}
